import React from 'react';
import { selectIsLoading } from '../../reducers/loading';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Card, CardContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import * as supportActions from '../../actions/support';
import IResyncUserRequest from '../../types/support/IResyncUserRequest';
import { selectReport } from '../../reducers/support';
import { useMsal } from '@azure/msal-react';
import IReportUserRequest from '../../types/support/IReportUserRequest';
import { isNull } from '../../utils/general';
import ResyncConfirmation from './ResyncConfirmation';
import { AnyAction, Dispatch } from 'redux';

const getReportAction = supportActions.createGetReportAction();
const resyncUserAction = supportActions.createResyncUserAction();

const handleResyncUser = (dispatch: Dispatch<AnyAction>, accountId: string, handleConfirmClose: () => void) => {
	const request = { UserId: accountId } as IResyncUserRequest;
	dispatch(resyncUserAction(request));
	handleConfirmClose();
}

const handleGetReport = (dispatch: Dispatch<AnyAction>, accountId: string) => {
	dispatch(getReportAction({ UserId: accountId } as IReportUserRequest));
}

export default () => 
{
	const [isConfirmOpen, setIsConfirmOpen] = React.useState(false);
	const isLoading = useSelector(selectIsLoading);
	const report = useSelector(selectReport);
	const { accounts } = useMsal();
	const dispatch = useDispatch();

	const handleConfirmOpen = () => setIsConfirmOpen(true);
	const handleConfirmClose = () => setIsConfirmOpen(false);

	React.useEffect(() => {
		// delay the dispatch to allow profile to be set
		setTimeout(() => handleGetReport(dispatch, accounts[0].localAccountId), 500);
		}, []);

	return (
		<React.Fragment>
			{!isLoading && report == null && <Typography>Kein Report vorhanden. Benutzer ist keine synchronisierte Liste.</Typography> }
			{report != null && (
				<React.Fragment>
					<Typography variant='h6' sx={{ mb: 1 }}>
						Zusammenfassung von Aktivitäten und Tasks für den aktuellen Benutzer
						<Tooltip title='Aktualisieren' placement='right'>
							<IconButton onClick={() => handleGetReport(dispatch, accounts[0].localAccountId)} size='small'><RefreshIcon color='primary'/></IconButton>
						</Tooltip>
					</Typography>
					<Typography variant='body2'>Um die Synchronistation, bei Fehlern, wieder anzustoßen, bitte auf den Resync-Button drücken.</Typography>
					<Grid sx={{ mb: 2, mt: 2 }} container className='container' alignItems='stretch' spacing={2}>
						<Grid item xs={12} sm={6} md={3}>
							<Card>
								<CardContent>
									<Typography variant="h6" color="textSecondary" gutterBottom>Anzahl Aktivitäten {report.TotalActivities}</Typography>
									<Typography variant="body1">offen: {report.TotalActivitiesOpen} geschlossen: {report.TotalActivitiesClosed}</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<Card>
								<CardContent>
									<Typography variant="h6" color="textSecondary" gutterBottom>Anzahl Tasks {report.TotalTasks}</Typography>
									<Typography variant="body1">offen: {report.TotalTasksOpen} geschlossen: {report.TotalTasks - report.TotalTasksOpen}</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<Card>
								<CardContent>
									<Typography variant="h6" color="textSecondary" gutterBottom>Anzahl Tasks mit Aktivtitäten {report.TotalTasksWithActivity}</Typography>
									<Typography variant="body1">offen: {report.TotalTasksWithActivityOpen} geschlossen: {report.TotalTasksWithActivity - report.TotalTasksWithActivityOpen}</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<Card>
								<CardContent>
									<Typography variant="h6" color="textSecondary" gutterBottom>Anzahl vollständig gesynchte Tasks {report.TotalSynchedUpdatedTasks}</Typography>
									<Typography variant="body1">offen: {report.TotalSynchedUpdatedTasks} geschlossen: {report.TotalSynchedUpdatedTasks - report.TotalSynchedUpdatedTasksOpen}</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12}>
							<Card>
								<CardContent>
									<Typography variant="h6" color="textSecondary" gutterBottom>Fehler</Typography>
									<Grid container spacing={2}>
										<Grid item xs={12} sm={6} md={3}>
											<Typography variant="h6" component="h2">Fehlende geöffnete Aktivitäten in Tasks {report.TotalMissingTaskActivitiesOpen}</Typography>
										</Grid>
										<Grid item xs={12} sm={6} md={3}>
											<Typography variant="h6" component="h2">Teilweise gesynchte geöffnete Tasks {report.TotalSynchedNotUpdatedActivitiesOpen}</Typography>
										</Grid>
										<Grid item xs={12} sm={6} md={3}>
											<Typography variant="h6" component="h2">
												Tasks, welche auf nicht-existierende Aktivitäten zeigen {!isNull(report.BrokenActivityRefTasks) ? report.BrokenActivityRefTasks.length : 0}
											</Typography>
										</Grid>		
									</Grid>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
					<Button sx={{ mr: 2 }} color='primary' disabled={isLoading} onClick={() => handleConfirmOpen()} variant='contained'>Resync</Button>
					<ResyncConfirmation 
						isOpen={isConfirmOpen} 
						handleClose={() => handleConfirmClose()}
						handleConfirmantion={() => handleResyncUser(dispatch, accounts[0].localAccountId, handleConfirmClose)} />
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

